import {
  GET_CONSULTATION_HISTORY,
  GET_CONSULTATION_HISTORY_SUCCESS,
  GET_CONSULTATION_HISTORY_FAILURE,
} from 'store/getConsultationHistory/getConsultationHistoryAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getConsultationHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONSULTATION_HISTORY:
      return { ...state, loading: true };
    case GET_CONSULTATION_HISTORY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_CONSULTATION_HISTORY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getConsultationHistoryReducer;
